<template>
    <div class="ml-auto mr-auto" style="max-width: 400px;">
        <form
            id="wfhResetPasswordForm"
            @submit="submitForm"
        >
            <div class="mt-30">
                <label
                    for="password"
                    class="wfh-form-label"
                    :class="{'text-danger': passwordError}"
                >
                    New Password
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': passwordError}"
                    style="background-image: none !important;"
                    type="password"
                    id="password"
                    v-model="password"/>
                <span v-if="passwordError" v-text="passwordError" class="wfh-err-label"></span>
            </div>

            <div class="progress mt-2" style="height: 8px;border-radius: 0;">
                <div
                    class="progress-bar"
                    :class="{
                        'bg-success': passwordScore > 3,
                        'bg-danger': passwordScore < 3,
                        'bg-warning': passwordScore === 3
                    }"
                    role="progressbar"
                    :style="{
                        'width': `${passwordScore * 25}%`
                    }"
                    :aria-valuenow="passwordScore"
                    aria-valuemin="0"
                    aria-valuemax="4"
                ></div>
            </div>

            <div class="mt-30">
                <label
                    for="passwordConfirmation"
                    class="wfh-form-label"
                    :class="{'text-danger': passwordConfirmationError}"
                >
                    Confirm New Password
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': passwordConfirmationError}"
                    style="background-image: none !important;"
                    type="password"
                    id="passwordConfirmation"
                    v-model="passwordConfirmation"/>
                <span v-if="passwordConfirmationError" v-text="passwordConfirmationError" class="wfh-err-label"></span>
            </div>

            <div class="wfh-paragraph py-3" style="font-size: 12px;line-height: 18px;">
                Use at least 8 characters include both lower and upper case and at least one number or symbol. Don’t use
                a password from another site, or something too obvious like your pet’s name.
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    :disabled="!formCompleted || loading"
                    class="btn wfh-btn-primary position-relative"
                    style="margin-top: 30px;"
                >
                    <span
                        class="spinner-border position-absolute"
                        role="status"
                        style="left: 16px;top: 10px;"
                        v-show="loading"
                    >
                        <span class="sr-only">Loading...</span>
                    </span>
                    Set new password
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import passwordStrengthMeter from 'zxcvbn';

    export default {
        props: ['email', 'token'],

        data() {
            return {
                loading: false,
                passwordScore: 0,
                passwordError: null,
                passwordConfirmationError: null,
                password: null,
                passwordConfirmation: null
            }
        },

        computed: {
            formCompleted() {
                return this.password && this.passwordConfirmation;
            }
        },

        watch: {
            'password'() {
                this.passwordScore = passwordStrengthMeter(this.password).score;
            }
        },

        methods: {
            async submitForm(e) {
                this.loading = true;
                e.preventDefault();
                this.resetValidation();

                if (this.validatePassword()) {
                  await axios.post('/password/reset', {
                    email: this.email,
                    token: this.token,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation
                  });

                  location.href = '/login';
                }

                this.loading = false;
            },

            validatePassword() {
                if (this.password.length < 8) {
                    this.passwordError = 'Password is too short';
                    return false
                }

                if (this.passwordScore < 3) {
                    this.passwordError = 'Password is too weak';
                    return false
                }

                if (this.password !== this.passwordConfirmation) {
                    this.passwordConfirmationError = 'Password does not match';
                    return false;
                }

                return true;
            },

            resetValidation() {
                this.passwordError = null;
                this.passwordConfirmationError = null;
            }
        }
    }
</script>

<style scoped>
    .mt-30 {
        margin-top: 30px;
    }
</style>
